import { render, staticRenderFns } from "./AssetManager.vue?vue&type=template&id=1457fd6d&"
import script from "./AssetManager.vue?vue&type=script&lang=js&"
export * from "./AssetManager.vue?vue&type=script&lang=js&"
import style0 from "./AssetManager.vue?vue&type=style&index=0&id=1457fd6d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports